const useWindow = () => {
    const getWindowDomain = () => window.location.origin

    const getWindowURL = () => window.location.href

    const getWindowQuery = () => window.location.search.split('?')[1]

    return { getWindowDomain, getWindowQuery, getWindowURL }
}

export default useWindow
